import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import { stringifyQuery } from 'utils/query';

export interface IXeroTimeeroUsersSearchQuery {
  page: number;
  page_size: number;
  search: string;
}

export const fetchPaginatedXeroTimeeroUsers = (searchQuery: IXeroTimeeroUsersSearchQuery) => {
  const stringifiedQuery = stringifyQuery(searchQuery);
  const newEndpoints = endpoints.integrations.xeroTimeeroUsers + '?' + stringifiedQuery;
  return http().get(newEndpoints);
};

export function useFetchPaginatedXeroTimeeroUsers(
  searchQuery: IXeroTimeeroUsersSearchQuery,
  options?: any
): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchPaginatedXeroTimeeroUsers', searchQuery],
    queryFn: () => fetchPaginatedXeroTimeeroUsers(searchQuery),
    ...options,
  });
}
